import axios from "axios";
import { toast } from "react-toastify";
import { UrlApi } from "../Keys";
import moment from "moment/moment";

let loadingToast = null;

const ToastLoading = (msj) => {
  loadingToast = toast.info(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  });
};

const ToastSuccess = (msj) => {
  toast.success(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast);
      }
    },
  });
};

const ToastError = (msj) => {
  toast.error(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast);
      }
    },
  });
};

const dataInicial = {
  vacaciones: [],
  getVacaciones: false,
  vacacionesIngresadas: [],
  getVacacionesIngresadas: false,
  vacacionesAprobadas: [],
  getVacacionesAprobadas: false,
  vacacionesNoAprobadas: [],
  getVacacionesNoAprobadas: false,
  vacacionesIngresadasEquipo: [],
  getVacacionesIngresadasEquipo: false,
  vacacionesAprobadasEquipo: [],
  getVacacionesAprobadasEquipo: false,
  vacacionesNoAprobadasEquipo: [],
  getVacacionesNoAprobadasEquipo: false,
  subperiodo: [],
  loadAprobarRechazarVacacionEquipo: "",
  loadSolicitudVacacion: "",
  subperiodoVacacional: [],
  loadSubperiodoVacacional: false,
  loadSubperiodoAprobarRechazar:"",
  licenciasVigentes: [],
  getLicenciasVigentes: false,
};

const LOADING_VACACIONES = "LOADING_VACACIONES";
const VACACIONES = "VACACIONES";
const VACACIONES_ERROR = "VACACIONES_ERROR";

const LOADING_VACACIONES_INGRESADAS = "LOADING_VACACIONES_INGRESADAS";
const VACACIONES_INGRESADAS = "VACACIONES_INGRESADAS";
const VACACIONES_INGRESADAS_ERROR = "VACACIONES_ERROR";

const LOADING_VACACIONES_APROBADAS = "LOADING_VACACIONES_APROBADAS";
const VACACIONES_APROBADAS = "VACACIONES_APROBADAS";
const VACACIONES_APROBADAS_ERROR = "VACACIONES_APROBADAS_ERROR";

const LOADING_VACACIONES_NOAPROBADAS = "LOADING_VACACIONES_NOAPROBADAS";
const VACACIONES_NOAPROBADAS = "VACACIONES_NOAPROBADAS";
const VACACIONES_NOAPROBADAS_ERROR = "VACACIONES_NOAPROBADAS_ERROR";

const LOADING_VACACIONES_INGRESADAS_EQUIPO =
  "LOADING_VACACIONES_INGRESADAS_EQUIPO";
const VACACIONES_INGRESADAS_EQUIPO = "VACACIONES_INGRESADAS_EQUIPO";
const VACACIONES_INGRESADAS_EQUIPO_ERROR = "VACACIONES_INGRESADAS_EQUIPO_ERROR";

const LOADING_VACACIONES_APROBADAS_EQUIPO =
  "LOADING_VACACIONES_APROBADAS_EQUIPO";
const VACACIONES_APROBADAS_EQUIPO = "VACACIONES_APROBADAS_EQUIPO";
const VACACIONES_APROBADAS_EQUIPO_ERROR = "VACACIONES_APROBADAS_EQUIPO_ERROR";

const LOADING_VACACIONES_NOAPROBADAS_EQUIPO =
  "LOADING_VACACIONES_NOAPROBADAS_EQUIPO";
const VACACIONES_NOAPROBADAS_EQUIPO = "VACACIONES_NOAPROBADAS_EQUIPO";
const VACACIONES_NOAPROBADAS_EQUIPO_ERROR =
  "VACACIONES_NOAPROBADAS_EQUIPO_ERROR";

const LOADING_SUBPERIODO_VACACIONAL = "LOADING_SUBPERIODO_VACACIONAL";
const SUBPERIODO_VACACIONAL = "SUBPERIODO_VACACIONAL";
const ERROR_SUBPERIODO_VACACIONAL = "ERROR_SUBPERIODO_VACACIONAL";

const LOADING_SOLICITUD_VACACION = "LOADING_SOLICITUD_VACACION";
const EXITO_SOLICITUD_VACACION = "EXITO_SOLICITUD_VACACION";
const ERROR_SOLICITUD_VACACION = "ERROR_SOLICITUD_VACACION";

const LOADING_APROBAR_RECHAZAR_VACACION = "LOADING_APROBAR_RECHAZAR_VACACION";
const EXITO_APROBAR_RECHAZAR_VACACION = "EXITO_APROBAR_RECHAZAR_VACACION";
const ERROR_APROBAR_RECHAZAR_VACACION = "ERROR_APROBAR_RECHAZAR_VACACION";

const LOADING_CANCELAR_VACACION = "LOADING_CANCELAR_VACACION";
const EXITO_CANCELAR_VACACION = "EXITO_CANCELAR_VACACION";
const ERROR_CANCELAR_VACACION = "ERROR_CANCELAR_VACACION";

const LOADING_SUBPERIODO_VACACIONAL_UO = "LOADING_SUBPERIODO_VACACIONAL_UO";
const SUBPERIODO_VACACIONAL_UO = "SUBPERIODO_VACACIONAL_UO";
const ERROR_SUBPERIODO_VACACIONAL_UO = "ERROR_SUBPERIODO_VACACIONAL_UO";

const LOADING_APROBAR_RECHAZAR_SUBPERIODO = "LOADING_APROBAR_RECHAZAR_SUBPERIODO"
const EXITO_APROBAR_RECHAZAR_SUBPERIODO = "EXITO_APROBAR_RECHAZAR_SUBPERIODO"
const ERROR_APROBAR_RECHAZAR_SUBPERIODO = "ERROR_APROBAR_RECHAZAR_SUBPERIODO"

const CLEAR_SUBPERIODO = "CLEAR_SUBPERIODO"

const LICENCIAS_VIGENTES_LOADING = "LICENCIAS_VIGENTES_LOADING"
const LICENCIAS_VIGENTES_EXITO = "LICENCIAS_VIGENTES_EXITO"
const LICENCIAS_VIGENTES_ERROR = "LICENCIAS_VIGENTES_ERROR"


//Reducers
export default function vacacionesReducer(state = dataInicial, action) {
  switch (action.type) {
    case LOADING_VACACIONES:
      return { ...state, getVacaciones: action.getVacaciones };
    case VACACIONES:
      return {
        ...state,
        vacaciones: action.payload,
        getVacaciones: action.getVacaciones,
      };
    case VACACIONES_ERROR:
      return { ...state, getVacaciones: action.getVacaciones };
    case LOADING_VACACIONES_INGRESADAS:
      return {
        ...state,
        getVacacionesIngresadas: action.getVacacionesIngresadas,
      };
    case VACACIONES_INGRESADAS:
      return {
        ...state,
        vacacionesIngresadas: action.payload,
        getVacacionesIngresadas: action.getVacacionesIngresadas,
      };
    case VACACIONES_INGRESADAS_ERROR:
      return {
        ...state,
        getVacacionesIngresadas: action.getVacacionesIngresadas,
      };
    case LOADING_VACACIONES_APROBADAS:
      return {
        ...state,
        getVacacionesAprobadas: action.getVacacionesAprobadas,
      };
    case VACACIONES_APROBADAS:
      return {
        ...state,
        vacacionesAprobadas: action.payload,
        getVacacionesAprobadas: action.getVacacionesAprobadas,
      };
    case VACACIONES_APROBADAS_ERROR:
      return {
        ...state,
        getVacacionesAprobadas: action.getVacacionesAprobadas,
      };
    case LOADING_VACACIONES_NOAPROBADAS:
      return {
        ...state,
        getVacacionesNoAprobadas: action.getVacacionesNoAprobadas,
      };
    case VACACIONES_NOAPROBADAS:
      return {
        ...state,
        vacacionesNoAprobadas: action.payload,
        getVacacionesNoAprobadas: action.getVacacionesNoAprobadas,
      };
    case VACACIONES_NOAPROBADAS_ERROR:
      return {
        ...state,
        getVacacionesNoAprobadas: action.getVacacionesNoAprobadas,
      };
    case LOADING_VACACIONES_INGRESADAS_EQUIPO:
      return {
        ...state,
        getVacacionesIngresadasEquipo: action.getVacacionesIngresadasEquipo,
      };
    case VACACIONES_INGRESADAS_EQUIPO:
      return {
        ...state,
        vacacionesIngresadasEquipo: action.payload,
        getVacacionesIngresadasEquipo: action.getVacacionesIngresadasEquipo,
      };
    case VACACIONES_INGRESADAS_EQUIPO_ERROR:
      return {
        ...state,
        getVacacionesIngresadasEquipo: action.getVacacionesIngresadasEquipo,
      };
    case LOADING_VACACIONES_APROBADAS_EQUIPO:
      return {
        ...state,
        getVacacionesAprobadasEquipo: action.getVacacionesAprobadasEquipo,
      };
    case VACACIONES_APROBADAS_EQUIPO:
      return {
        ...state,
        vacacionesAprobadasEquipo: action.payload,
        getVacacionesAprobadasEquipo: action.getVacacionesAprobadasEquipo,
      };
    case VACACIONES_APROBADAS_EQUIPO_ERROR:
      return {
        ...state,
        getVacacionesAprobadasEquipo: action.getVacacionesAprobadasEquipo,
      };
    case LOADING_VACACIONES_NOAPROBADAS_EQUIPO:
      return {
        ...state,
        getVacacionesNoAprobadasEquipo: action.getVacacionesNoAprobadasEquipo,
      };
    case VACACIONES_NOAPROBADAS_EQUIPO:
      return {
        ...state,
        vacacionesNoAprobadasEquipo: action.payload,
        getVacacionesNoAprobadasEquipo: action.getVacacionesNoAprobadasEquipo,
      };
    case VACACIONES_NOAPROBADAS_EQUIPO_ERROR:
      return {
        ...state,
        getVacacionesNoAprobadasEquipo: action.getVacacionesNoAprobadasEquipo,
      };
    case SUBPERIODO_VACACIONAL:
      return { ...state, subperiodo: action.payload };
    case LOADING_APROBAR_RECHAZAR_VACACION:
      return { ...state, loadAprobarRechazarVacacionEquipo: action.resultado };
    case EXITO_APROBAR_RECHAZAR_VACACION:
      return { ...state, loadAprobarRechazarVacacionEquipo: action.resultado };
    case ERROR_APROBAR_RECHAZAR_VACACION:
      return { ...state, loadAprobarRechazarVacacionEquipo: action.resultado };
    case LOADING_CANCELAR_VACACION:
      return { ...state, loadCancelarVacacion: action.resultado };
    case EXITO_CANCELAR_VACACION:
      return { ...state, loadCancelarVacacion: action.resultado };
    case ERROR_CANCELAR_VACACION:
      return { ...state, loadCancelarVacacion: action.resultado };
    case LOADING_SOLICITUD_VACACION:
      return { ...state, loadSolicitudVacacion: action.resultado };
    case EXITO_SOLICITUD_VACACION:
      return { ...state, loadSolicitudVacacion: action.resultado };
    case ERROR_SOLICITUD_VACACION:
      return { ...state, loadSolicitudVacacion: action.resultado };
    case LOADING_SUBPERIODO_VACACIONAL_UO :
      return { ...state, loadSubperiodoVacacional: action.resultado };
    case SUBPERIODO_VACACIONAL_UO:
      return { ...state, subperiodoVacacional: action.payload,loadSubperiodoVacacional: action.resultado };
    case ERROR_SUBPERIODO_VACACIONAL_UO:
      return { ...state, loadSubperiodoVacacional: action.resultado };
    case LOADING_APROBAR_RECHAZAR_SUBPERIODO :
        return { ...state, loadSubperiodoAprobarRechazar: action.resultado };
    case EXITO_APROBAR_RECHAZAR_SUBPERIODO:
        return { ...state ,loadSubperiodoAprobarRechazar: action.resultado };
    case ERROR_APROBAR_RECHAZAR_SUBPERIODO:
        return { ...state, loadSubperiodoAprobarRechazar: action.resultado };
    case CLEAR_SUBPERIODO:
      return {...state, loadSubperiodoVacacional: false, subperiodoVacacional: []}
    case LICENCIAS_VIGENTES_LOADING :
        return { ...state, getLicenciasVigentes: action.getLicenciasVigentes };
    case LICENCIAS_VIGENTES_EXITO:
        return { ...state, licenciasVigentes: action.payload, getLicenciasVigentes: action.getLicenciasVigentes };
    case LICENCIAS_VIGENTES_ERROR:
        return { ...state, getLicenciasVigentes: action.getLicenciasVigentes };

    default:
      return { ...state };
  }
}

export const vacaciones = (token, fechaHoy, usuarioPortalRh) => async (dispatch) => {
  dispatch({
    type: LOADING_VACACIONES,
    getVacaciones: false,
  });

  try {
    var entidad = "new_vacacioneses";
    var fetch = `
    
    <entity name="new_vacaciones">
      <attribute name="new_vacacionesid" />
      <attribute name="new_name" />
      <attribute name="new_empleado" />
    <attribute name="createdon" />
     <attribute name="new_diasvacacionescorrespondientes" />
      <attribute name="new_totaldiassolicitados" />
       <attribute name="new_diasvacacionestomados" /> 
       <attribute name="new_diasvacacionespendientes" />
         <attribute name="new_periodovacacional"/>
        <attribute name="new_diasvacacionesadicionales" />
      <order attribute="new_name" descending="false" />
      <filter type="and">
        <condition attribute="statuscode" operator="eq" value="1" />
      </filter>
      <link-entity name="new_empleado" from="new_empleadoid" to="new_empleado" link-type="inner" alias="aa">
        <filter type="and">
          <condition attribute="new_correoelectronico" operator="eq" value="${usuarioPortalRh}" />
        </filter>
      </link-entity>
      <link-entity name="new_periodovacacionaldefinido" from="new_periodovacacionaldefinidoid" to="new_periodovacacional" link-type="inner" alias="ab">
         <attribute name="new_name" />
      <filter type="and">
          <condition attribute="new_publicado" operator="eq" value="1" />
          <condition attribute="new_fechahasta" operator="on-or-after" value="${fechaHoy}" />
        </filter>
      </link-entity>
    </entity>
  `

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: VACACIONES,
      payload: response.data,
      getVacaciones: true,
    });
  } catch (error) {
    dispatch({
      type: VACACIONES_ERROR,
      getVacaciones: true,
    });
  }
};

export const vacacionesIngresadas = (token, usuarioPortalRH) => async (dispatch) => {
    dispatch({
      type: LOADING_VACACIONES_INGRESADAS,
      getVacacionesIngresadas: false,
    });

    try {
      var entidad = "new_licencias";
      var fetch = `
      <entity name="new_licencia">
        <attribute name="new_name" />
        <attribute name="new_aprobacionrecursoshumanos" />
        <attribute name="new_fechahasta" />
        <attribute name="new_fechadesde" />
        <attribute name="new_fechadesolicitud" />
        <attribute name="statuscode" />
        <attribute name="new_licenciaid" />
        <attribute name="new_diassolicitados" />
        <attribute name="new_aprobacionsupervisor" />
        <attribute name="new_tipodelicencia" />
        <attribute name="new_empleado" />
        <order attribute="new_name" descending="false" />
        <filter type="and">
          <condition attribute="new_empleadoportal" operator="eq" value="${usuarioPortalRH}" />
          <condition attribute="statuscode" operator="in">
            <value>1</value>
          </condition>
        </filter>
        <link-entity name="new_tipodelicencia" from="new_tipodelicenciaid" to="new_tipodelicencia" link-type="inner" alias="al">
          <filter type="and">
            <condition attribute="new_segmento" operator="eq" value="100000004" />
          </filter>
        </link-entity>
      </entity>`;

      const response = await axios.post(
        `${UrlApi}api/consultafetch`,
        {
          entidad: entidad,
          fetch: fetch,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: VACACIONES_INGRESADAS,
        payload: response.data,
        getVacacionesIngresadas: true,
      });
    } catch (error) {
      dispatch({
        type: VACACIONES_INGRESADAS_ERROR,
        getVacacionesIngresadas: true,
      });
    }
  };

export const vacacionesAprobadas = (token, usuarioPortalRH) => async (dispatch) => {
    dispatch({
      type: LOADING_VACACIONES_APROBADAS,
      getVacacionesAprobadas: false,
    });

    try {
      var entidad = "new_licencias";
      var fetch = `
      <entity name="new_licencia">
        <attribute name="new_name" />
        <attribute name="new_aprobacionrecursoshumanos" />
        <attribute name="new_fechahasta" />
        <attribute name="new_fechadesde" />
        <attribute name="new_fechadesolicitud" />
        <attribute name="statuscode" />
      <attribute name="new_diassolicitados" />
        <attribute name="new_licenciaid" />
        <attribute name="new_tipodelicencia" />
        <attribute name="new_empleado" />
        <order attribute="new_name" descending="false" />
        <filter type="and">
          <condition attribute="new_empleadoportal" operator="eq" value="${usuarioPortalRH}" />
          <condition attribute="statuscode" operator="in">
            <value>100000000</value>
           </condition>
        </filter>
        <link-entity name="new_tipodelicencia" from="new_tipodelicenciaid" to="new_tipodelicencia" link-type="inner" alias="al">
          <filter type="and">
            <condition attribute="new_segmento" operator="eq" value="100000004" />
          </filter>
        </link-entity>
        <link-entity name="new_vacaciones" from="new_vacacionesid" to="new_vacaciones" link-type="outer" alias="ad">
          <attribute name="new_diasvacacionespendientes" />
        </link-entity>
      </entity>`

      const response = await axios.post(
        `${UrlApi}api/consultafetch`,
        {
          entidad: entidad,
          fetch: fetch,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: VACACIONES_APROBADAS,
        payload: response.data,
        getVacacionesAprobadas: true,
      });
    } catch (error) {
      dispatch({
        type: VACACIONES_APROBADAS_ERROR,
        getVacacionesAprobadas: true,
      });
    }
  };

export const vacacionesNoAprobadas = (token, usuarioPortalRH) => async (dispatch) => {
    dispatch({
      type: LOADING_VACACIONES_NOAPROBADAS,
      getVacacionesNoAprobadas: false,
    });

    try {
      var entidad = "new_licencias";
      var fetch = `
      <entity name="new_licencia">
        <attribute name="new_name" />
        <attribute name="new_aprobacionrecursoshumanos" />
        <attribute name="new_fechahasta" />
        <attribute name="new_fechadesde" />
        <attribute name="new_fechadesolicitud" />
        <attribute name="statuscode" />
        <attribute name="new_diassolicitados" />
        <attribute name="new_licenciaid" />
        <attribute name="new_tipodelicencia" />
        <attribute name="new_empleado" />
        <order attribute="new_name" descending="false" />
        <filter type="and">
          <condition attribute="new_empleadoportal" operator="eq" value="${usuarioPortalRH}" />
          <condition attribute="statuscode" operator="in">
            <value>100000001</value>
        <value>100000002</value>
          </condition>
        </filter>
        <link-entity name="new_tipodelicencia" from="new_tipodelicenciaid" to="new_tipodelicencia" link-type="inner" alias="al">
          <filter type="and">
            <condition attribute="new_segmento" operator="eq" value="100000004" />
          </filter>
        </link-entity>
      </entity>`;

      const response = await axios.post(
        `${UrlApi}api/consultafetch`,
        {
          entidad: entidad,
          fetch: fetch,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: VACACIONES_NOAPROBADAS,
        payload: response.data,
        getVacacionesNoAprobadas: true,
      });
    } catch (error) {
      dispatch({
        type: VACACIONES_NOAPROBADAS_ERROR,
        getVacacionesNoAprobadas: true,
      });
    }
  };

export const vacacionesIngresadasEquipoFetch = (token, usuarioPortalRH) => async (dispatch) => {
    dispatch({
      type: LOADING_VACACIONES_INGRESADAS_EQUIPO,
      getVacacionesIngresadasEquipo: false,
    });

    try {
      var entidad = "new_licencias";
      var fetch =`
      <entity name="new_licencia">
        <attribute name="new_name" />
        <attribute name="new_aprobacionrecursoshumanos" />
        <attribute name="new_fechahasta" />
        <attribute name="new_fechadesde" />
        <attribute name="new_fechadesolicitud" />
        <attribute name="new_tipodelicencia" />
        <attribute name="new_subperiodovacacionaldefinido" />
        <attribute name="new_aprobador1" />
        <attribute name="new_aprobador2" />
        <attribute name="new_aprobador3" />
        <attribute name="statuscode" />
      <attribute name="new_diassolicitados" />
      <attribute name="new_licenciaid" />
        <attribute name="new_empleado" />
        <order attribute="new_name" descending="false" />
         <filter type="and">
          <condition attribute="statuscode" operator="eq" value="1" />
          <filter type="or">
            <filter type="and">
              <condition attribute="new_aprobacionsupervisor" operator="null" />
              <condition attribute="new_usuarioportalaprobador1" operator="eq" value="${usuarioPortalRH}" />
            </filter>
            <filter type="and">
              <condition attribute="new_aprobacionsupervisor" operator="eq" value="100000000" />
              <condition attribute="new_aprobacion2" operator="null" />
              <condition attribute="new_usuarioportalaprobador2" operator="eq" value="${usuarioPortalRH}" />
            </filter>
            <filter type="and">
              <condition attribute="new_aprobacionsupervisor" operator="eq" value="100000000" />
              <condition attribute="new_aprobacion2" operator="eq" value="100000000" />
              <condition attribute="new_aprobacion3" operator="null" />
              <condition attribute="new_usuarioportalaprobador3" operator="eq" value="${usuarioPortalRH}" />
            </filter>
          </filter>
        </filter>
        <link-entity name="new_tipodelicencia" from="new_tipodelicenciaid" to="new_tipodelicencia" link-type="inner" alias="ai">
          <filter type="and">
            <condition attribute="new_segmento" operator="eq" value="100000004" />
          </filter>
        </link-entity>
      </entity>`;

      const response = await axios.post(
        `${UrlApi}api/consultafetch`,
        {
          entidad: entidad,
          fetch: fetch,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: VACACIONES_INGRESADAS_EQUIPO,
        payload: response.data,
        getVacacionesIngresadasEquipo: true,
      });
    } catch (error) {
      dispatch({
        type: VACACIONES_INGRESADAS_EQUIPO_ERROR,
        getVacacionesIngresadasEquipo: true,
      });
    }
  };

export const vacacionesAprobadasEquipo = (token, usuarioPortalRH) => async (dispatch) => {
    dispatch({
      type: LOADING_VACACIONES_APROBADAS_EQUIPO,
      getVacacionesAprobadasEquipo: false,
    });

    try {
      var entidad = "new_licencias";
      var fetch = `
      <entity name="new_licencia">
        <attribute name="new_name" />
        <attribute name="new_aprobacionrecursoshumanos" />
        <attribute name="new_fechahasta" />
        <attribute name="new_fechadesde" />
        <attribute name="new_fechadesolicitud" />
        <attribute name="statuscode" />
        <attribute name="new_diassolicitados" />
        <attribute name="new_licenciaid" />
        <attribute name="new_tipodelicencia" />
        <attribute name="new_empleado" />
        <order attribute="new_name" descending="false" />
         <filter type="and">
          <filter type="or">
            <filter type="and">
              <condition attribute="new_aprobacionsupervisor" operator="eq" value="100000000" />
              <condition attribute="new_usuarioportalaprobador1" operator="eq" value="${usuarioPortalRH}" />
            </filter>
            <filter type="and">
              <condition attribute="new_aprobacion2" operator="eq" value="100000000" />
              <condition attribute="new_usuarioportalaprobador2" operator="eq" value="${usuarioPortalRH}" />
            </filter>
            <filter type="and">
              <condition attribute="new_aprobacion3" operator="eq" value="100000000" />
              <condition attribute="new_usuarioportalaprobador3" operator="eq" value="${usuarioPortalRH}" />
            </filter>
          </filter>
        </filter>
        <link-entity name="new_tipodelicencia" from="new_tipodelicenciaid" to="new_tipodelicencia" link-type="inner" alias="ac">
          <filter type="and">
            <condition attribute="new_segmento" operator="eq" value="100000004" />
          </filter>
        </link-entity>
        <link-entity name="new_vacaciones" from="new_vacacionesid" to="new_vacaciones" link-type="outer" alias="ad">
          <attribute name="new_diasvacacionespendientes" />
        </link-entity>
      </entity>`;

      const response = await axios.post(
        `${UrlApi}api/consultafetch`,
        {
          entidad: entidad,
          fetch: fetch,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: VACACIONES_APROBADAS_EQUIPO,
        payload: response.data,
        getVacacionesAprobadasEquipo: true,
      });
    } catch (error) {
      dispatch({
        type: VACACIONES_APROBADAS_EQUIPO_ERROR,
        getVacacionesAprobadasEquipo: true,
      });
    }
  };

export const vacacionesNoAprobadasEquipoFetch =
  (token, usuarioPortalRH) => async (dispatch) => {
    dispatch({
      type: LOADING_VACACIONES_NOAPROBADAS_EQUIPO,
      getVacacionesNoAprobadasEquipo: false,
    });

    try {
      var entidad = "new_licencias";
      var fetch =
        "<entity name='new_licencia'>" +
        "<attribute name='new_name' />" +
        "<attribute name='createdon' />" +
        "<attribute name='new_aprobacionrecursoshumanos' />" +
        "<attribute name='new_fechahasta' />" +
        "<attribute name='new_fechadesde' />" +
        "<attribute name='new_fechadesolicitud' />" +
        "<attribute name='statuscode' />" +
        "<attribute name='new_diassolicitados' />" +
        "<attribute name='new_licenciaid' />" +
        "<attribute name='new_tipodelicencia' />" +
        "<attribute name='new_empleado' />" +
        "<order attribute='createdon' descending='true' />" +
        "<filter type='and'>" +
        "<filter type='and'>" +
        "<condition attribute='statuscode' operator='in'>" +
        "<value>1</value>" +
        "<value>100000000</value>" +
        "<value>100000001</value>" +
        "</condition>" +
        "<filter type='or'>" +
        "<filter type='and'>" +
        "<condition attribute='new_usuarioportalaprobador1' operator='like' value='" +
        usuarioPortalRH +
        "' />" + //que email?
        "<condition attribute='new_aprobacionsupervisor' operator='eq' value='100000001' />" +
        "</filter>" +
        "<filter type='and'>" +
        "<condition attribute='new_usuarioportalaprobador2' operator='like' value='" +
        usuarioPortalRH +
        "' />" + //que email?
        "<condition attribute='new_aprobacion2' operator='eq' value='100000001' />" +
        "</filter>" +
        "<filter type='and'>" +
        "<condition attribute='new_usuarioportalaprobador3' operator='like' value='" +
        usuarioPortalRH +
        "' />" + //que email?
        "<condition attribute='new_aprobacion3' operator='eq' value='100000001' />" +
        "</filter>" +
        "</filter>" +
        "</filter>" +
        "</filter>" +
        "<link-entity name='new_tipodelicencia' from='new_tipodelicenciaid' to='new_tipodelicencia' link-type='inner' alias='bj'>" +
        "<filter type='and'>" +
        "<condition attribute='new_segmento' operator='eq' value='100000004' />" +
        "</filter>" +
        "</link-entity>" +
        "</entity>";

      const response = await axios.post(
        `${UrlApi}api/consultafetch`,
        {
          entidad: entidad,
          fetch: fetch,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: VACACIONES_NOAPROBADAS_EQUIPO,
        payload: response.data,
        getVacacionesNoAprobadasEquipo: true,
      });
    } catch (error) {
      dispatch({
        type: VACACIONES_NOAPROBADAS_EQUIPO_ERROR,
        getVacacionesNoAprobadasEquipo: true,
      });
    }
  };

export const subperiodoVacacional = (token, periodovacacionaldefinido, fechaHoy) => async (dispatch) => {
    dispatch({
      type: LOADING_SUBPERIODO_VACACIONAL,
    });

    try {
      var entidad = "new_subperiodovacacionaldefinidos";
      var fetch =
        "<entity name='new_subperiodovacacionaldefinido'>" +
        "<attribute name='new_subperiodovacacionaldefinidoid' />" +
        "<attribute name='new_name' />" +
        "<attribute name='createdon' />" +
        "<attribute name='new_fechahastahabilitada' />" +
        "<attribute name='new_fechadesdehabilitada' />" +
        "<order attribute='new_fechadesdehabilitada' descending='false' />" +
        "<filter type='and'>" +
        "<condition attribute='new_periodovacacionalasociado' operator='eq' uitype='new_periodovacacionaldefinido' value='" +
        periodovacacionaldefinido +
        "' />" +
        "<condition attribute='statecode' operator='eq' value='0' />" +
        "<condition attribute='new_fechahastahabilitada' operator='on-or-after' value= '"+fechaHoy+"' />"+
        "</filter>" +
        "</entity>";

      const response = await axios.post(
        `${UrlApi}api/consultafetch`,
        {
          entidad: entidad,
          fetch: fetch,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: SUBPERIODO_VACACIONAL,
        payload: response.data,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: ERROR_SUBPERIODO_VACACIONAL,
      });
    }
  };

export const solicitudVacaciones =
  (token, datos, id, empleado) => async (dispatch) => {
    dispatch({
      type: LOADING_SOLICITUD_VACACION,
      resultado: "LOADING",
    });
    ToastLoading("Procesando...")
    return new Promise((resolve, reject) => {
      if (Object.keys(datos).length > 0 && token) {
        axios
          .post(
            `${UrlApi}api/hrfactors/vacaciones`,
            {
              new_tipodelicencia: datos.tipoLicencia.value,
              new_empleado: empleado,
              new_subperiodovacacionaldefinido: datos.periodovacacional ? datos.periodovacacional.value : "",
              new_fechadesolicitud: datos.fechaDeSolicitud ? moment(datos.fechaDeSolicitud).format("YYYY-MM-DD") : "",
              new_diassolicitados: datos.diasSolicitados? Number(datos.diasSolicitados): 0,
              new_fechadesde: datos.fechaDesde ? moment(datos.fechaDesde).format("YYYY-MM-DD"): "",
              new_vacaciones: id
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            dispatch({
              type: EXITO_SOLICITUD_VACACION,
              resultado: "EXITO",
              payload: response.data,
            });

            ToastSuccess("Vacación cargada con éxito");
            resolve(response.data);
          })
          .catch((error) => {
            console.log(error);

            dispatch({
              type: ERROR_SOLICITUD_VACACION,
              resultado: "ERROR",
            });

            ToastError(error.response.data);
            reject(error);
          });
      }
    });
  };

export const cancelarVacacionesMetodo = (token, datos) => async (dispatch) => {
  dispatch({
    type: LOADING_CANCELAR_VACACION,
    resultado: "LOADING",
  });
  ToastLoading("Procesando...")
  return new Promise((resolve, reject) => {
    if (Object.keys(datos).length > 0 && token) {
      axios
        .post(
          `${UrlApi}api/hrfactors/vacaciones`,
          {
            new_licenciaId: datos.id,
            new_diassolicitados: datos.diasSolicitados ? Number(datos.diasSolicitados) : 0,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          dispatch({
            type: EXITO_CANCELAR_VACACION,
            resultado: "EXITO",
            payload: response.data,
          });

          ToastSuccess("Vacación cancelada con éxito");
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);

          dispatch({
            type: ERROR_CANCELAR_VACACION,
            resultado: "ERROR",
          });

          ToastError(error.response.data);
          reject(error);
        });
    }
  });
};

export const aprobarRechazarLicencia = (token, datos) => async (dispatch) => {
  dispatch({
    type: LOADING_APROBAR_RECHAZAR_VACACION,
    resultado: "LOADING",
  });
  ToastLoading("Procesando...")
  return new Promise((resolve, reject) => {
    if (Object.keys(datos).length > 0 && token) {
      axios.put(`${UrlApi}api/hrfactors/aprobarrechazarvacaciones`,
          {
            new_licenciaId: datos.id,
            "new_aprobacionsupervisor": datos.aprobacion1 ? Number(datos.aprobacion1) : 0,
            "new_aprobacion2": datos.aprobacion2 ? Number(datos.aprobacion2) : 0,
            "new_aprobacion3": datos.aprobacion3 ? Number(datos.aprobacion3) : 0,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          dispatch({
            type: EXITO_APROBAR_RECHAZAR_VACACION,
            resultado: "EXITO",
            payload: response.data,
          });

          ToastSuccess("Vacación aprobada/rechazada con éxito");
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);

          dispatch({
            type: ERROR_APROBAR_RECHAZAR_VACACION,
            resultado: "ERROR",
          });

          ToastError(error.response.data);
          reject(error);
        });
    }
  });
};

export const getSubperiodovacacional = (token, usuarioPortalRH) => async (dispatch) => {
    dispatch({
      type: LOADING_SUBPERIODO_VACACIONAL_UO,
      resultado: false,
    });
    try {
      var entidad = "new_subperiodovacacionalporas";
      var fetch =
        "<entity name='new_subperiodovacacionalpora'>" +
        "<attribute name='new_unidadorganizativa' />" +
        "<attribute name='new_porcentajeacumplirobjetivo' />" +
        "<attribute name='new_porcentajelicenciasenelsubperiodo' />" +
        "<attribute name='new_name' />" +
        "<attribute name='new_subperiodovacacionalporaid' />" +
        "<attribute name='new_tamaonomina' />"+
        "<attribute name='new_cantidadlicencias' />"+
        "<attribute name='new_aprobador' />"+
        "<attribute name='new_aprobacion' />"+
        "<attribute name='statuscode' />" +
        "<order attribute='new_unidadorganizativa' descending='false' />" +
        "<filter type='and'>" +
        "<condition attribute='statecode' operator='eq' value='0' />" +
        "</filter>" +
        "<link-entity name='new_subperiodovacacionaldefinido' from='new_subperiodovacacionaldefinidoid' to='new_subperiodovacacionalasociado' visible='false' link-type='outer' alias='subper'>" +
        "<attribute name='new_name' />" +
        "<attribute name='new_fechahastahabilitada' />" +
        "<attribute name='new_fechadesdehabilitada' />" +
        "</link-entity>" +
        "<link-entity name='new_unidadorganigrama' from='new_unidadorganigramaid' to='new_unidadorganizativa' visible='false' link-type='outer' alias='unidad'>" +
        "<attribute name='new_unidadsuperior' />" +
        "</link-entity>" +
        "<link-entity name='new_empleado' from='new_empleadoid' to='new_aprobador' link-type='inner' alias='aa'>" +
        "<filter type='and'>" +
        "<condition attribute='new_correoelectronico' operator='like' value='" +
        usuarioPortalRH +
        "' />" +
        "</filter>" +
        "</link-entity>" +
        "</entity>";

      const response = await axios.post(
        `${UrlApi}api/consultafetch`,
        {
          entidad: entidad,
          fetch: fetch,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: SUBPERIODO_VACACIONAL_UO,
        payload: response.data,
        resultado: true,
      });
    } catch (error) {
      dispatch({
        type: ERROR_SUBPERIODO_VACACIONAL_UO,
        resultado: true,
      });
    }
  };

  export const clearSubperiodo = () => async (dispatch) => {
    dispatch({
      type: CLEAR_SUBPERIODO,
    })
  }

  export const aprobarRechazarSubperiodo = (token, id, estado) => async (dispatch) => {
    dispatch({
      type: LOADING_APROBAR_RECHAZAR_SUBPERIODO,
      resultado: "LOADING",
    });
    ToastLoading("Procesando...")
    return new Promise((resolve, reject) => {
      if (estado.length > 0 && token) {
        axios.put(`${UrlApi}api/hrfactors/subperiodovacacional`,
            {
              "new_subperiodovacacionalporaid": id,
              "new_aprobacion": estado ? Number(estado) : 0
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then((response) => {
            dispatch({
              type: EXITO_APROBAR_RECHAZAR_SUBPERIODO,
              resultado: "EXITO",
              payload: response.data,
            });
  
            ToastSuccess("Subperiodo aprobada/rechazada con éxito");
            resolve(response.data);
          })
          .catch((error) => {
            console.log(error);
  
            dispatch({
              type: ERROR_APROBAR_RECHAZAR_SUBPERIODO,
              resultado: "ERROR",
            });
  
            ToastError(error.response.data);
            reject(error);
          });
      }
    });
  };


export const licenciasVigentes = (token, usuarioPortalRH, periodovacacionaldefinidoid) => async (dispatch) => {

  dispatch({
    type: LICENCIAS_VIGENTES_LOADING,
    getLicenciasVigentes: false,
  });

  try {
    var entidad = "new_licencias";
    var fetch = `
    <entity name="new_licencia">
      <attribute name="new_licenciaid" />
      <attribute name="new_name" />
      <attribute name="createdon" />
      <attribute name="new_tipodelicencia" />
      <order attribute="new_name" descending="false" />
      <filter type="and">
        <condition attribute="new_empleadoportal" operator="eq" value="${usuarioPortalRH}" />
        <condition attribute="new_tipodelicencia" operator="eq" value="{E6839DDC-6314-EB11-A813-000D3AC0AEFA}" />
        <condition attribute="statecode" operator="eq" value="0" />
        <condition attribute="statuscode" operator="in">
          <value>100000000</value>
          <value>100000003</value>
          <value>100000005</value>
          <value>100000004</value>
          <value>1</value>
        </condition>
      </filter>
      <link-entity name="new_subperiodovacacionaldefinido" from="new_subperiodovacacionaldefinidoid" to="new_subperiodovacacionaldefinido" link-type="inner" alias="ab">
        <filter type="and">
          <condition attribute="new_periodovacacionalasociado" operator="eq" uitype='new_periodovacacionaldefinido' value="${periodovacacionaldefinidoid}" />
        </filter>
      </link-entity>
    </entity>`;

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({
      type: LICENCIAS_VIGENTES_EXITO,
      payload: response.data,
      getLicenciasVigentes: true,
    });
  } catch (error) {
    dispatch({
      type: LICENCIAS_VIGENTES_ERROR,
      getLicenciasVigentes: true,
    });
  }
};

